// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Uew","buttons":"styles_buttons__Cl3Hu"};